import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DxTreeListComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FusionAuthService } from '../../../../../../shared/services/fusion-auth';
import { ScreenService, UrlProviderService } from '../../../../../../shared/services/general';
import { ResultBase } from '../../../models/results';
import { OrdersService } from '../../../../../shared/services/orders.service';

@Component({
  selector: 'app-toxicology-unexpected-negative',
  templateUrl: './toxicology-unexpected-negative.component.html',
  styleUrls: ['./toxicology-unexpected-negative.component.scss']
})
export class ToxicologyUnexpectedNegativeComponent implements OnInit, OnChanges  {
    @ViewChild('toxiUnexpectedNegativeTree', { static: true }) private tree?: DxTreeListComponent;
    @Input() public orderId: number = -1;
    public isLoading = false;
    public dataSource: ResultBase[] = [];
    public hasResults = false;
    public isPhoneOrTablet: boolean = false;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private orderService: OrdersService, private urlProvider: UrlProviderService, private fusionAuthService: FusionAuthService, private screen: ScreenService) {
    }

    public ngOnInit() {
        this.isLoading = true;
        this.orderService.getOrderToxicologyInconsistentNegativeResults(this.orderId)
            .subscribe(result => {
                this.hasResults = result.length > 0;
                this.dataSource = result;
            });


        this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        });

    }

  public ngOnChanges(changes: SimpleChanges): void {
      if (changes.orderId.currentValue) {
        this.isLoading = true;
        this.orderService.getOrderToxicologyInconsistentNegativeResults(changes.orderId.currentValue)
          .subscribe(result => {
            this.hasResults = result.length > 0;
            this.dataSource = result;
          });
      }
  }
}
